import styled from "styled-components";

import ChevronUpIcon from "../../../assets/images/chevron-up.svg";
import ChevronUpWhiteIcon from "../../../assets/images/chevron-up-white.svg";
import ChevronDownIcon from "../../../assets/images/chevron-down.svg";
import ChevronDownWhiteIcon from "../../../assets/images/chevron-down-white.svg";

export const TableV1 = styled.table`
    width: 100%;

    border-collapse: collapse;
    border-radius: 6px;

    overflow: hidden;

    thead {
        tr {
            &:not(:first-child) {
                th {
                    border-radius: 0 !important;
                }
            }

            th {
                padding: 0.75rem;

                background: var(--color-orange4);
                color: var(--color-grey9);
                text-align: left;

                vertical-align: middle;

                border: none !important;

                &:first-child {
                    border-top-left-radius: 6px;
                }

                &:last-child {
                    border-top-right-radius: 6px;
                }

                &.has-sort {
                    span {
                        width: 100%;

                        display: block;
                        position: relative;

                        border: none;

                        cursor: pointer;

                        padding-right: 16px;

                        &::before {
                            content: "";
                            width: 10px;
                            height: 10px;

                            position: absolute;
                            top: calc(50% - 10px);
                            right: 0;

                            background-image: url(${(props) =>
                                props.theme.theme === "light" ? ChevronUpIcon : ChevronUpWhiteIcon});
                            background-size: cover;
                            background-position: center;
                            background-repeat: no-repeat;

                            transition: 0.2s all ease-in-out;
                            opacity: 0.4;
                        }

                        &::after {
                            content: "";
                            width: 10px;
                            height: 10px;

                            position: absolute;
                            top: calc(50% + 2px);
                            right: 0;

                            background-image: url(${(props) =>
                                props.theme.theme === "light" ? ChevronDownIcon : ChevronDownWhiteIcon});
                            background-size: cover;
                            background-position: center;
                            background-repeat: no-repeat;

                            transition: 0.2s all ease-in-out;
                            opacity: 0.4;
                        }
                    }

                    &.asc {
                        span {
                            &::before {
                                opacity: 1;
                            }
                        }
                    }

                    &.desc {
                        span {
                            &::after {
                                opacity: 1;
                            }
                        }
                    }
                }
            }
        }
    }

    tbody {
        tr {
            &:nth-child(even) {
                td {
                    background: var(--color-grey2);
                }
            }

            td {
                padding: 0.75rem;

                background: var(--color-grey1);

                color: var(--color-grey10);

                vertical-align: middle;

                border: none !important;
            }

            &:last-child {
                td {
                    &:first-child {
                        border-bottom-left-radius: 6px;
                    }

                    &:last-child {
                        border-bottom-right-radius: 6px;
                    }
                }
            }
        }
    }
`;
